export { default } from "./CurricUnitModalContent";
